"use client";

import { Chevron } from "@faire/web/slate/icons/Chevron";
import { getSpacing } from "@faire/web/slate/spacing";
import { EmbeddedLink } from "@faire/web/ui/EmbeddedLink";
import styled from "styled-components";

export const BrandNameArrow: React.FC<{
  linkTo: string;
  onClick?: () => void;
}> = ({ linkTo, onClick }) => {
  const clickHandler = onClick ?? (() => {});
  return (
    <StyledLink linkTo={linkTo} onClick={clickHandler}>
      <StyledChevron direction="right" fontSize={getSpacing(12)} />
    </StyledLink>
  );
};

const StyledLink = styled(EmbeddedLink)`
  padding-left: ${getSpacing("1x")};
  position: relative;
`;

export const StyledChevron = styled(Chevron)`
  stroke-width: 2px;
`;
